import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './HHM_Main.html?raw';
import on from 'dojo/on';
import "../../WebCalendar_TS/MainProperties/MainProperties";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import MainPropertiesV2 from '../../WebCalendar_TS/MainProperties/MainPropertiesV2';
import { TicketTypes } from "../../TicketPool/TicketTypes";
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import TicketContingentView from '../../TicketPool/TicketContingentView/TicketContingentView';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import { ToasterHelpers } from "../../../more/Helpers";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";
//import EvBookingEditor = require("../../EvBookingEditor/EvBookingEditor");
//import "../../EvBookingEditor/EvBookingEditor";



class HHM_Main extends compose(_WidgetBaseSP) {
    
    templateString: any = template;

    private cbAutoRefresh: MdsLax<InstanceType<typeof CheckBox>>;
    private txtLastRefresh: HTMLElement;

    private mainProperties: MdsLax<InstanceType<typeof MainPropertiesV2>>;
    //private currentBookingEditor: EvBookingEditor = null;
    private bookingEditingEnabledForCurrentUser: boolean = false;

    private _calendarCreated() {

    }

    private sectionAutoRefresh: HTMLElement;
    private sectionTicketContingents: HTMLElement;
    private ticketContingentsForm: HTMLElement;
    private ticketContingentsSelectContainer: HTMLElement;
    private ticketContingents: Array<TicketTypes.TicketContingentEntity>;
    private ticketContingent_preselected: string;
    private _ticketContingentsRequest: dojo.request.Promise<any>;

    showBookingDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        this.mainProperties.openDefaultDetailView(item); // mal standard aufrufen

        // ... aber erweitern: Daten für den Editor requesten
        
        let dlg = this.mainProperties.itemView;

        dlg.on("closed", lang.hitch(this, this._onItemDlgCallback));

        // Report-Download machen
        if (item.Classname === "ev_booking") {

            if (this.hasUserRole("RD_Eventbriefing")) {
                dlg.addButton("briefingReport",
                    this.translations["WebCalendar__DetailView_button_BriefingReport"],
                    lang.hitch(this, this._onClick_Report, item, "briefing"),
                    null,
                    null,
                    "fas fa-print",
                    false,
                    "left last");
            }

            if (this.hasUserRole("RD_Technikbriefing")) {
                dlg.addButton("technicReport",
                    this.translations["WebCalendar__DetailView_button_TechnikReport"],
                    lang.hitch(this, this._onClick_Report, item, "technic"),
                    null,
                    null,
                    "fas fa-print",
                    false,
                    "left last");
            }

            if (this.hasFeature("Ticketpool/ShowInWebcalendar") && this.hasUserRole("TicketPool")) {
                
                this.loadAvailableTicketContingents(item);

              
            }
        }
    }

    private _onItemDlgCallback(result) {
        // normaler Webkalender nutzt kein Callback, wir brauchen es hier damit wir ggf. den Request canceln
        this.hideNode(this.sectionTicketContingents);
        this.UiModder.domConstruct.place(this.sectionTicketContingents, this.domNode, "last");
        if (this._ticketContingentsRequest) this._ticketContingentsRequest.cancel();
    }

    private loadAvailableTicketContingents(item: WebcalendarTypes.WebCalendarItemData_Default) {

        this.ticketContingents = [];
        this._ticketContingentsRequest = this.RequestManager.callfunction(
            "Webtool_API_TicketPool__GetTicketContingentsForItem",
            { bookingID: item.id },
            lang.hitch(this, this._onTicketContingentsResponse),
            lang.hitch(this, this._onTicketContingentsError),
            false
        );


    }
    private _onTicketContingentsResponse(response: { preselectedID?: string, ticketContingents: Array<TicketTypes.TicketContingentEntity> }) {
        this.ticketContingents = response.ticketContingents;
        this.ticketContingent_preselected = response.preselectedID;
        if (this.mainProperties.itemView && this.ticketContingents?.length) {
            let node = this.mainProperties.itemView.addButton("ticketPool",
                this.translate("TicketPool_MainTitle"),
                lang.hitch(this, this._openTicketContingents),
                null,
                "w3-blue-gray",
                "fas fa-ticket-alt",
                false,
                "left last",);
        }
    }

    private _onTicketContingentsError(error: more.requestErrorMessage) {

    }

    private _openTicketContingents(evt: MouseEvent) {

        let select = new SelectBox();
        select.setBlankOption("", "--");
        select.setLabel(this.translate("TicketPool_Label_TicketContingent"))
        select.setData(this.ticketContingent_preselected,
            this.ticketContingents,
            "ID",
            "$Displayname",
            false,
            "ref_special_ticket_contingent_type.coloration",
            "ref_special_ticket_contingent_type.coloration"
        );
        select.placeAt(this.ticketContingentsSelectContainer, "only");

        this.hideNode(this.sectionTicketContingents, false);

        select.on("change", lang.hitch(this, this._onSelectTicketContingent));

        this.ticketContingents[0].ref_special_ticket_contingent_type.coloration

        let dlg = new GenericDialog();
        dlg.show(this.sectionTicketContingents,
            null,
            null,
            null,
            "close");

        if (this.ticketContingents.length == 1) select.setValue(this.ticketContingents[0].ID);
    }

    private _onSelectTicketContingent(value: string) {

        let form = new TicketContingentView();
        form.placeAt(this.ticketContingentsForm, "only");
        form.loadData(value);
    }

    private _onClick_Report(item: WebcalendarTypes.WebCalendarItemData_Default, type: "briefing" | "technic",evt: MouseEvent) {

        let url = window.appRoot + "Downloads/CreateReportForDownload";

        let data = {
            "bookingID": item.id,
            "reportType": type
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onDownloadReady),
            lang.hitch(this, this._onRequestReportError),
            false // sync
        );

        this.StandbyStart(this.mainProperties.itemView.domNode);
    }

    private _onDownloadReady(entity: FileFinder.FileDescriptor) {
        //debugger;
        this.StandbyStop();
        //console.log("_onClick_Download", entity);
        location.href = window.appRoot + this.stringFormat("FileDashboard/Download?downloadKey={0}&fileName={1}.{2}",
            entity.downloadKey,
            entity.filename,
            entity.extension);
    }

    private _onRequestReportError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }



    //private _checkIfBookingEditingEnabledForCurrentUser(): void {

    //    this.hasUserRole("BOOKING_EDITOR", lang.hitch(this, this._showBookingEditorInterface));
    //}

    //private _showBookingEditorInterface(bool?: boolean): void {
    //    //console.log("_showBookingEditorInterface", bool);
    //    this.bookingEditingEnabledForCurrentUser = bool === true;

    //    if (this.bookingEditingEnabledForCurrentUser == true) {

    //        let createBookingBtn = this.UiModder.domConstruct.create("BUTTON", {
    //            innerHTML: this.translations["WebCalendar_SidebarPane_btnLabel_createBooking"],
    //            className: "mds-button-base round mds-hover-dark w3-block",
    //            onclick: lang.hitch(this, this._onclickOpenBookingEditor)
    //        });

    //        this.mainProperties.addCustomPane("evBookingEditorPane", this.translations["WebCalendar_SidebarPane_paneLabel_bookingEditor"], createBookingBtn, "fas fa-calendar-plus");

    //    } else {
    //        this.mainProperties.removePane("evBookingEditorPane");
    //    }
    //}
    private _onDataLoaded(): void {

        let now = new Date();
        let nowStr = this.dateTimeToString(now, "dd.MM.yyyy HH:mm:ss");
        this.txtLastRefresh.innerHTML = nowStr;

    }
    private _setupMainPropertes(): void{

        if (this.mainProperties != null) {
            this.mainProperties.destroy();
            this.mainProperties = null;
        }

        this.mainProperties = new MainPropertiesV2();

        on(this.mainProperties, "calendarCreated", lang.hitch(this, this._calendarCreated));
        on(this.mainProperties, "loaded", lang.hitch(this, this._onDataLoaded));
        
        this.UiModder.domConstruct.place(this.mainProperties.domNode, this.domNode, "first");

        let detailFct = lang.hitch(this, this.showBookingDetails);

        this.mainProperties.setMainConfig({
            itemDetails: {
                customItemClickFunction: detailFct
                //requestUrl: 
            },
            resourceClickFct: lang.hitch(this, this._onclick_Resource)

            //userProperties: {
            //    customFunctionName: "Webtool_API_Webcalendar__GetUserProperties",
            //    requestUrl: "Calendar/GetUserProperties",
            //    //requestParams: [{ name: "jsonData", value: { user: "unknown" } }]
            //},
            //filterData: {
            //    requestUrl: "Calendar/GetFilterData",
            //    customFunctionName: "Webtool_API_Webcalendar__GetFilterData"
            //},
        //    defaultDisplaySettings: {
        //        b_show_end_time: true,
        //        //hideColumnHead: true
        //    }
        });
        
        this.mainProperties.startup();

        this._preparePanels();

        // Titel überschreiben, der vom Webkalender gesetzt würde
        //this.mainProperties.setTitles(
        //    this.stringFormat(this.translations["KWittCalendar__MainTitle"], this.translations["MainTitle"]),
        //    this.translations["KWittCalender__Title"]);

    }
    private _onclick_Resource(resource: WebcalendarTypes.SyncfusionCalendarResource) {
        alert(resource.label);
    }

    private _preparePanels(): void {
        if (!this.mainProperties) {
            return;
        }

        let props = this.mainProperties;

        //props.addCustomPane(....)
        props.addNodeToPane(WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane, this.sectionAutoRefresh);
    }

    private _execAutorefresh() {
        if (document.visibilityState == "hidden") return;

        this.mainProperties.loadData();
    }
    private _autorefreshTimeout: any = null;
    private _onChange_Autorefresh() {
        let value = this.cbAutoRefresh.getValue() as boolean;

        if (this._autorefreshTimeout) clearInterval(this._autorefreshTimeout);
        localStorage.setItem("WebCalendar_Autorefresh", value.toString());
        if (value === true) {
            this._autorefreshTimeout = setInterval(lang.hitch(this, this._execAutorefresh), 1000 * 60 * 10);
            this.showToast({
                timeout: 20000,
                iconClass: ToasterHelpers.ToasterIcons.info,
                title: this.translate("Webcalendar_Toast_AutoRefreshActive"),
                ID: "autorefresh",
                showClose: true,
                options: {
                    buttons: [{
                        callback: lang.hitch(this, function () { this.cbAutoRefresh.setValue(false); }),
                        label: this.translate("General_SetAsInactive"),
                        icon: "fas fa-power-off"
                    }]
                }
            });
        } else {
            this.removeToast("autorefresh");
        }
    }


    private _onVisibilityChanged(evt) {
        //let state: DocumentVisibilityState = document.visibilityState;

    //    console.debug(this.id + " visibility", state, evt);
    }


    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.none, timeout?: number, extendedMessage?: string): void {
        if (!this.mainProperties) {
            alert(text);
            console.error(text, extendedMessage);
            return;
        }
        this.mainProperties.publishToastMessage(text, icon, timeout, extendedMessage)
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addSubscription("/Global/VisibilityChange", lang.hitch(this, this._onVisibilityChanged));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        //this._isStartup = true;
        //this._continueWithSession();
        //this._checkUrlParameters();
        this._setupMainPropertes();

        //this._checkIfBookingEditingEnabledForCurrentUser();
        let autorefreshSetting = localStorage.getItem("WebCalendar_Autorefresh");
        if (autorefreshSetting == "true") {
            this.cbAutoRefresh.setValue(true);
        }
    }

}

export default mdsWidget(HHM_Main);